export const TOOLBAR_ITEM = {
  BOLD: 'bold',
  ITALIC: 'italic',
  UNDERLINE: 'underline',
  LINK: 'link',
  H1: 'h1',
  H2: 'h2',
  BLOCKQUOTE: 'blockquote',
  NUMLIST: 'numlist',
  BULLIST: 'bullist',
  FULLSCREEN: 'fullscreen',
  IMAGE: 'image',
  MEDIA: 'media',
  CODE: 'code',
  DELIMITER: '|',
  TWITTER: 'tweet',
  YOUTUBE: 'youtube',
  INSTAGRAM: 'instagram',
  TOOLTIP: 'tooltip',
  CTA: 'CTA',
  TABLE: 'table',
  FORMAT_SELECT: 'formatselect',
  UNDO: 'undo',
  REDO: 'redo',
  REMOVE_FORMAT: 'removeformat',
  BACK_COLOR: 'backcolor',
  ALIGN_LEFT: 'alignleft',
  ALIGN_RIGHT: 'alignright',
  ALIGN_CENTER: 'aligncenter',
  ALIGN_JUSTIFY: 'alignjustify',
  INDENT: 'indent',
  OUTDENT: 'outdent',
};

export const DEFAULT_TOOLBAR = [
  TOOLBAR_ITEM.UNDO,
  TOOLBAR_ITEM.REDO,
  TOOLBAR_ITEM.DELIMITER,
  TOOLBAR_ITEM.FORMAT_SELECT,
  TOOLBAR_ITEM.DELIMITER,
  TOOLBAR_ITEM.BOLD,
  TOOLBAR_ITEM.ITALIC,
  TOOLBAR_ITEM.UNDERLINE,
  TOOLBAR_ITEM.BACK_COLOR,
  TOOLBAR_ITEM.DELIMITER,
  TOOLBAR_ITEM.ALIGN_LEFT,
  TOOLBAR_ITEM.ALIGN_CENTER,
  TOOLBAR_ITEM.ALIGN_RIGHT,
  TOOLBAR_ITEM.ALIGN_JUSTIFY,
  TOOLBAR_ITEM.DELIMITER,
  TOOLBAR_ITEM.LINK,
  TOOLBAR_ITEM.BLOCKQUOTE,
  TOOLBAR_ITEM.DELIMITER,
  TOOLBAR_ITEM.NUMLIST,
  TOOLBAR_ITEM.BULLIST,
  TOOLBAR_ITEM.OUTDENT,
  TOOLBAR_ITEM.INDENT,
  TOOLBAR_ITEM.DELIMITER,
  TOOLBAR_ITEM.TABLE,
  TOOLBAR_ITEM.DELIMITER,
  TOOLBAR_ITEM.IMAGE,
  TOOLBAR_ITEM.MEDIA,
  TOOLBAR_ITEM.DELIMITER,
  TOOLBAR_ITEM.FULLSCREEN,
  TOOLBAR_ITEM.CODE,
  TOOLBAR_ITEM.DELIMITER,
  TOOLBAR_ITEM.REMOVE_FORMAT,
  TOOLBAR_ITEM.CTA,
];

export const PLUGINS = ['lists fullscreen autolink link image media code tooltip table'];
